import mergeModuleConfigs from 'core/utils/mergeModuleConfigs';
import { emailOptInHome as orgConfig } from 'org/configs/modules.config';

const defaultConfig = {
  defaults: {
    emailOptionsSubscribe: {
      email_news_optin: 1,
      email_odotw_optin: 1,
      email_promo_optin: 1,
      email_global_optout: 0,
    },
    emailOptionsUnsubscribe: {
      email_news_optin: 0,
      email_odotw_optin: 0,
      email_promo_optin: 0,
      email_global_optout: 1,
    },
    getMarketingProgramName: () => '',
    form: 'UpdateMember',
    formAction: 'auth.php',
  },
};

export default mergeModuleConfigs(defaultConfig, orgConfig);
